import(/* webpackMode: "eager", webpackExports: ["PortalClientRedirect"] */ "/home/runner/work/ark/ark/@apps/web/src/app/[locale]/portal/PortalClientRedirect.tsx");
